import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VOverlay,{attrs:{"opacity":1,"value":_vm.overlay}},[_c(VProgressCircular,{attrs:{"indeterminate":"","size":"200"}},[_vm._v(" Een momentje aub... ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }